import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import Footer from '../components/Footer';
import OrderStatus from '../components/OrderStatus';

export default function Feedback() {
  
  // State for each question's rating (initializing as an empty object)
  const [ratings, setRatings] = useState({
    customerService: 0,
    ambience: 0,
    pricing: 0,
    food: 0,
    beverage: 0,
    cleanliness: 0,
  });

  const [hoveredRating, setHoveredRating] = useState(0); // To manage hover effect

  // Array of emoji ratings (from worst to best)
  const emojis = [
    { id: 1, emoji: '😡', label: 'Very Bad' },
    { id: 2, emoji: '😕', label: 'Bad' },
    { id: 3, emoji: '😐', label: 'Neutral' },
    { id: 4, emoji: '🙂', label: 'Good' },
    { id: 5, emoji: '😄', label: 'Excellent' },
  ];

  const handleClick = (question, rating) => {
    setRatings(prevRatings => ({
      ...prevRatings,
      [question]: rating
    }));
  };

  const handleMouseEnter = (rating) => {
    setHoveredRating(rating);
  };

  const handleMouseLeave = () => {
    setHoveredRating(0);
  };

  return (
    <div className="container-fluid p-0 mt-4 mb-0">
      <PageHeader />

      <div className="container">
        {/* breadcrumb */}
        <div className="row">
          <div className="col-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item"><a href="/">Home</a></li>
                <li className="breadcrumb-item active" aria-current="page">Give Feedback</li>
              </ol>
            </nav>
          </div>
        </div>
        {/* breadcrumb */}

        {/* order status box */}
        <div className="row">
          <OrderStatus />
        </div>
        {/* order status box */}

        <div className="row">
          <div className="col-12 mb-4">
            <form>

              {/* Customer Service Question */}
              <div className="bg-white mb-4 p-4 rounded-3">
                <ol className="mb-2">
                  <li className="ol_li" value="1">How would you rate our customer service?</li>
                </ol>

                {/* Emoji rating bar */}
                <div className="emoji-bar" style={{ display: 'flex', justifyContent: 'center', gap: '25px' }}>
                  {emojis.map((emoji) => (
                    <div
                      key={emoji.id}
                      className={`emoji ${ratings.customerService >= emoji.id || hoveredRating >= emoji.id ? 'selected' : ''}`}
                      onClick={() => handleClick('customerService', emoji.id)}
                      onMouseEnter={() => handleMouseEnter(emoji.id)}
                      onMouseLeave={handleMouseLeave}
                      style={{ cursor: 'pointer', fontSize: '2rem' }}
                    >
                      <span role="img" aria-label={emoji.label}>
                        {emoji.emoji}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Display selected rating */}
                <div className="rating-result">
                  {ratings.customerService > 0 && <p className="mb-0">You rated: {emojis.find((emoji) => emoji.id === ratings.customerService).label}</p>}
                </div>
              </div>

              {/* ====================== */}

              {/* Ambience Question */}
              <div className="bg-white mb-4 p-4 rounded-3">
                <ol className="mb-2">
                  <li className="ol_li" value="2">How was the ambience of our coffee shop?</li>
                </ol>

                {/* Emoji rating bar */}
                <div className="emoji-bar" style={{ display: 'flex', justifyContent: 'center', gap: '25px' }}>
                  {emojis.map((emoji) => (
                    <div
                      key={emoji.id}
                      className={`emoji ${ratings.ambience >= emoji.id || hoveredRating >= emoji.id ? 'selected' : ''}`}
                      onClick={() => handleClick('ambience', emoji.id)}
                      onMouseEnter={() => handleMouseEnter(emoji.id)}
                      onMouseLeave={handleMouseLeave}
                      style={{ cursor: 'pointer', fontSize: '2rem' }}
                    >
                      <span role="img" aria-label={emoji.label}>
                        {emoji.emoji}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Display selected rating */}
                <div className="rating-result">
                  {ratings.ambience > 0 && <p className="mb-0">You rated: {emojis.find((emoji) => emoji.id === ratings.ambience).label}</p>}
                </div>
              </div>

              {/* ====================== */}

              {/* Pricing Question */}
              <div className="bg-white mb-4 p-4 rounded-3">
                <ol className="mb-2">
                  <li className="ol_li" value="3">Do you think our prices are fair?</li>
                </ol>

                {/* Emoji rating bar */}
                <div className="emoji-bar" style={{ display: 'flex', justifyContent: 'center', gap: '25px' }}>
                  {emojis.map((emoji) => (
                    <div
                      key={emoji.id}
                      className={`emoji ${ratings.pricing >= emoji.id || hoveredRating >= emoji.id ? 'selected' : ''}`}
                      onClick={() => handleClick('pricing', emoji.id)}
                      onMouseEnter={() => handleMouseEnter(emoji.id)}
                      onMouseLeave={handleMouseLeave}
                      style={{ cursor: 'pointer', fontSize: '2rem' }}
                    >
                      <span role="img" aria-label={emoji.label}>
                        {emoji.emoji}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Display selected rating */}
                <div className="rating-result">
                  {ratings.pricing > 0 && <p className="mb-0">You rated: {emojis.find((emoji) => emoji.id === ratings.pricing).label}</p>}
                </div>
              </div>

              {/* ====================== */}

              {/* Food Question */}
              <div className="bg-white mb-4 p-4 rounded-3">
                <ol className="mb-2">
                  <li className="ol_li" value="4">How did you like the food?</li>
                </ol>

                {/* Emoji rating bar */}
                <div className="emoji-bar" style={{ display: 'flex', justifyContent: 'center', gap: '25px' }}>
                  {emojis.map((emoji) => (
                    <div
                      key={emoji.id}
                      className={`emoji ${ratings.food >= emoji.id || hoveredRating >= emoji.id ? 'selected' : ''}`}
                      onClick={() => handleClick('food', emoji.id)}
                      onMouseEnter={() => handleMouseEnter(emoji.id)}
                      onMouseLeave={handleMouseLeave}
                      style={{ cursor: 'pointer', fontSize: '2rem' }}
                    >
                      <span role="img" aria-label={emoji.label}>
                        {emoji.emoji}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Display selected rating */}
                <div className="rating-result">
                  {ratings.food > 0 && <p className="mb-0">You rated: {emojis.find((emoji) => emoji.id === ratings.food).label}</p>}
                </div>
              </div>

              {/* ====================== */}

              {/* Beverage Question */}
              <div className="bg-white mb-4 p-4 rounded-3">
                <ol className="mb-2">
                  <li className="ol_li" value="5">How was your beverage?</li>
                </ol>

                {/* Emoji rating bar */}
                <div className="emoji-bar" style={{ display: 'flex', justifyContent: 'center', gap: '25px' }}>
                  {emojis.map((emoji) => (
                    <div
                      key={emoji.id}
                      className={`emoji ${ratings.beverage >= emoji.id || hoveredRating >= emoji.id ? 'selected' : ''}`}
                      onClick={() => handleClick('beverage', emoji.id)}
                      onMouseEnter={() => handleMouseEnter(emoji.id)}
                      onMouseLeave={handleMouseLeave}
                      style={{ cursor: 'pointer', fontSize: '2rem' }}
                    >
                      <span role="img" aria-label={emoji.label}>
                        {emoji.emoji}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Display selected rating */}
                <div className="rating-result">
                  {ratings.beverage > 0 && <p className="mb-0">You rated: {emojis.find((emoji) => emoji.id === ratings.beverage).label}</p>}
                </div>
              </div>

              {/* ====================== */}

              {/* Cleanliness Question */}
              <div className="bg-white mb-4 p-4 rounded-3">
                <ol className="mb-2">
                  <li className="ol_li" value="6">Were our facilities clean and comfortable?</li>
                </ol>

                {/* Emoji rating bar */}
                <div className="emoji-bar" style={{ display: 'flex', justifyContent: 'center', gap: '25px' }}>
                  {emojis.map((emoji) => (
                    <div
                      key={emoji.id}
                      className={`emoji ${ratings.cleanliness >= emoji.id || hoveredRating >= emoji.id ? 'selected' : ''}`}
                      onClick={() => handleClick('cleanliness', emoji.id)}
                      onMouseEnter={() => handleMouseEnter(emoji.id)}
                      onMouseLeave={handleMouseLeave}
                      style={{ cursor: 'pointer', fontSize: '2rem' }}
                    >
                      <span role="img" aria-label={emoji.label}>
                        {emoji.emoji}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Display selected rating */}
                <div className="rating-result">
                  {ratings.cleanliness > 0 && <p className="mb-0">You rated: {emojis.find((emoji) => emoji.id === ratings.cleanliness).label}</p>}
                </div>
              </div>

              {/* ====================== */}

              {/* Additional Comment */}
              <div className="bg-white mb-4 p-4 rounded-3">
                <ol className="mb-2">
                  <li className="ol_li" value="7">Any Additional Comment?</li>
                </ol>

                <div className="form-floating mb-3">
                  <textarea
                    className="form-control"
                    placeholder="Leave a comment here"
                    id="floatingTextarea2"
                    style={{ height: '100px' }}
                  ></textarea>
                  <label htmlFor="floatingTextarea2">Your Comment</label>
                </div>
              </div>

              {/* ====================== */}

              <div className="col-12 text-center">
                <button type="button" className="btn d-block black_btn mb-3 m-auto" style={{ width: '200px' }}>
                  SUBMIT
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
